import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import _ from 'lodash';
import { ISubmissionMetadata } from '@publishing-engine/domain/models';
import { generateValidationSchema } from 'src/utils/validation';
import { FormProvider, useForm } from 'react-hook-form';
import { ajvResolver } from '@hookform/resolvers/ajv';
import { FormFieldFunding } from '@publishing-engine/domain/types/article';
import FundingForm, { IFundingValue } from './FundingForm';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (value: IFundingValue) => void;
  formField: FormFieldFunding;
  value?: ISubmissionMetadata['funding'];
}

const FundingUpdateModal: React.FC<Props> = props => {
  const { isOpen, onClose, formField, onSubmit } = props;

  const defaultValues = _.set(
    {} as IFundingValue,
    formField.caseDataFields.main,
    props.value
  );

  const schema = generateValidationSchema({ Funding: formField });

  const methods = useForm({
    defaultValues,
    resolver: ajvResolver(schema)
  });
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="755px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(data => {
            onSubmit(data);
            onClose();
          })}
        >
          <Flex
            padding={8}
            gap={6}
            bgColor="surfacePrimaryFill"
            flexDirection="column"
            borderRadius="base"
          >
            <Flex maxHeight={700} overflow={'auto'}>
              <FundingForm formField={formField} />
            </Flex>
            <Flex
              gap={2}
              justifyContent="flex-end"
              alignItems="center"
              alignSelf="stretch"
            >
              <Button
                variant="secondary"
                onClick={onClose}
                borderRadius="small"
              >
                Exit Without Saving
              </Button>
              <Button variant="primary" type="submit" borderRadius="small">
                Save Changes
              </Button>
            </Flex>
          </Flex>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default FundingUpdateModal;
